import MenuList from "@/components/MenuList/MenuList.vue"
import btnCloseNotBorder from "@/components/btnCloseNotBorder/btnCloseNotBorder.vue"
import CustomDropdownBorder from '@/components/CustomDropdownBorder/CustomDropdownBorder.vue'
import CustomTooltipLeft from '@/components/CustomTooltipLeft/CustomTooltipLeft.vue'
import Hint from "@/components/Hint/Hint.vue"
import SidebarBurger from "../SidebarBurger/SidebarBurger.vue";
import MobileMenu from "@/components/MobileMenu/MobileMenu.vue";
import {mapGetters} from "vuex"

export default {
    //getEndTrial: Date.parse('01 Sep 2020'),
    name: 'Navbar',
    data() {
        return {
            avatar: "",
            visibleB: true,
            tooltipDropdown: [
                {option: 'Profile settings', href: "/profile-settings"},
            ],
            name: false,
            path: false,
            showArrow: false
        }
    },
    components: {
        MenuList, btnCloseNotBorder, CustomDropdownBorder, CustomTooltipLeft, Hint, SidebarBurger, MobileMenu
    },
    created() {
        this.checkRoute()
    },
    methods: {
        visibleBubble() {
            this.visibleB = !this.visibleB
        },
        toShaderSettings() {
            this.$router.push('/new-gate');
        },
        logout() {
            this.$store.dispatch('logout').then(resp => {
                this.$router.push('/')
            });
            if (this.isLogByFB) {
                this.$store.dispatch('logoutFB')
            }
        },
        checkRoute() {
            const to = (this.getRoutes.to && this.getRoutes.to.matched[0].path) ? this.getRoutes.to.matched[0].path : false
            if (to === "/my-gates/:id") {
                const id = this.getRoutes.to.params.id
                this.$store.dispatch('contentById', {id})
                    .then(resp => {
                            const item = resp.data
                            this.name = item.name
                        }
                    )
                this.path = '/my-gates'
                this.showArrow = true
            }
            if (to === "/new-gate") {
                this.name = 'New Content'
                this.path = '/my-gates'
                this.showArrow = true
            }
            if (to === "/my-gates") {
                this.name = 'My gates'
                this.path = '/my-gates'
                this.showArrow = false

            }
            if (to === '/pricing' || to === '/support' || to === '/instruction' || to === '/secure') {
                this.name = 'Back to Homepage'
                this.path = '/'
                this.showArrow = true
            }
            if (to === "/pricing/:plan_name") {
                this.name = 'Back to pricing'
                this.path = '/pricing'
                this.showArrow = true
            }
            if (to === "/support/ticket/:id") {
                this.name = 'Back to tickets list'
                this.path = '/support'
                this.showArrow = true
            }
            if (to === "/profile-settings") {
                this.name = 'Back to Homepage'
                this.path = '/'
                this.showArrow = true
            }
            if (to === "/terms-of-service") {
                this.name = 'Back to Homepage'
                this.path = '/'
                this.showArrow = true
            }
            if (to === "/profile-settings/change-password") {
                this.name = 'Back to profile settings'
                this.path = '/profile-settings'
                this.showArrow = true
            }


        },
        clickHandler(event) {           //click outside the element
            const {target} = event;
            const {$el} = this;
            if (!$el.contains(target)) {
                this.visibleB = true;
            }
        },
        test() {
            this.visibleB = false
        }
    },
    mounted() {
        document.addEventListener('click', this.clickHandler);
    },
    computed: {
        ...mapGetters(['getRoutes', 'isLoggedIn', 'userInfo', 'isLogByFB', 'getActivePlanId', 'getEndTrial','getTrialPlanPeriod','getMaxAvailablePlans']),
        nowDate(){
            return Date.parse(new Date())
        },
        endDateConvert(){
            let convertDate = new Date(this.getEndTrial)
            return (Number(convertDate.getMonth()) + 1) + '/' + Number(convertDate.getDate()) + '/' + convertDate.getFullYear()
        },
        userEmail() {
            //return JSON.parse(localStorage.getItem('user')).email
        }
    },
    watch: {
        $route: 'checkRoute'
    }
}

